import './scss/app.scss';
import * as bootstrap from 'bootstrap';
import _header from './js/header/header.menu-toggle';

window.bootstrap = bootstrap;

(($, Drupal) => {
    Drupal.behaviors.timelineComponent = {
      attach: function (context, settings) {
        _header.init();
      }
    };
  })(jQuery, Drupal);